import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { TLeasingFile, TLeasingOrderDetailed } from '../../../types';
import type { TLlpLeasingOrderStore } from './types';

const initialState: TLlpLeasingOrderStore = {
  activeTabIndex: 0,
  files: [],
  refreshToken: 0,
  request: null
};

export const llpLeasingOrderSlice = createSlice({
  name: 'llpLeasingOrder',
  initialState,
  reducers: {
    resetLlpLeasingOrder: () => {
      return initialState;
    },
    setActiveTabIndex: (state, action: PayloadAction<number>) => {
      state.activeTabIndex = action.payload;
    },
    setRequestData: (
      state,
      action: PayloadAction<{
        request: TLeasingOrderDetailed;
        files: TLeasingFile[];
      }>
    ) => {
      const { request: payloadRequest, files: payloadFiles } = action.payload;

      state.files = payloadFiles;
      state.request = payloadRequest;
    },
    refreshOrderData: (state) => {
      state.refreshToken += 1;
    }
  }
});

export const {
  resetLlpLeasingOrder,
  setActiveTabIndex,
  setRequestData,
  refreshOrderData
} = llpLeasingOrderSlice.actions;
